export default {
  outbound: 'Abreise',
  inbound: 'Rückreise',
  hide: 'Verbergen',
  details: 'Details',
}
